document.addEventListener('DOMContentLoaded', function () {
	const accordionItems = document.querySelectorAll('.wp-block-coblocks-accordion-item details');

	accordionItems.forEach((item) => {
	  const summary = item.querySelector('summary'); // Seleciona o botão de controle do acordeão
	  summary.addEventListener('click', function (event) {
		// Se o acordeão já está aberto, deixe ele fechar
		if (item.open) {
		  return;
		}

		// Fecha todos os outros acordeões
		accordionItems.forEach((otherItem) => {
		  if (otherItem !== item && otherItem.open) {
			otherItem.removeAttribute('open');
		  }
		});
	  });
	});
  });
